import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import {
  getProjectCompletionApplicationIncludes,
  PROJECT_COMPLETION__SUB_VIEWS
} from 'sh-www/constants/routes/project-completion';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectAdvanceRoute extends Route {
  @service('states/routes/project-completion') state;
  @service('state-managers/routes/project-completion') stateManager;
  @service session;

  model({ projectIdOrSlug }) {
    this.state.init();
    this.stateManager.setIsAdvancePayment(true);
    // Set expedite to true for buyers by default
    const { currentUser } = this.session;
    this.set('state.expedite', currentUser.isBuyer);
    return this.stateManager.loadApplication.perform(projectIdOrSlug, getProjectCompletionApplicationIncludes(currentUser));
  }

  afterModel() {
    this.stateManager.updateTestBillingRecord.perform();
  }

  activate(transition) {
    super.activate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: true,
      simpleHeaderText: this.session.currentUser.isBuyer ? 'Submit advance' : 'Request advance',
      simpleHeaderRightText: 'Cancel',
      simpleHeaderRightAction: () => {
        this.stateManager.handleCancelClicked();
      }
    });

    this.stateManager.setSubView(PROJECT_COMPLETION__SUB_VIEWS.NONE);
    trackPageViewFromTransition(this, transition, '/project-advance/:id');
  }

  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: false,
      simpleHeaderText: '',
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null
    });
  }
}

export default ProjectAdvanceRoute;
